/* Footer language and country disclosures work as plain <details>; with JS, Escape closes the open one
   and returns focus to its summary, and opening one or clicking elsewhere closes the other. */
const footerDisclosures = () => document.querySelectorAll('[data-section="site-footer"] details:is(.language-selector, .country-selector)');
for (const details of footerDisclosures()) {
  details.addEventListener('toggle', () => {
    if (details.open) for (const other of footerDisclosures()) if (other !== details) other.open = false;
  });
  details.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !details.open) return;
    details.open = false;
    details.querySelector('summary').focus();
  });
}
document.addEventListener('click', event => {
  for (const details of footerDisclosures()) if (details.open && !details.contains(event.target)) details.open = false;
});
